import { createContext } from "react";
/** `null` is the "no provider" sentinel; `useTheme()` turns it into a throw. */
export const ThemeContext = createContext(null);
//# sourceMappingURL=theme-context.js.map